export default "__VITE_ASSET__382181e3__$_?component__"